<template>
    <v-container grid-list-sm>
        <v-layout row wrap v-show="!selectedCustomer._id">
            <v-flex xs12>
                <v-alert :value="true" type="info" outline>
                    <div @click.stop="">
                        Please <a href="javascript:;" @click.stop="gotoCustomers">select a customer</a> to use the interactive price list.
                    </div>
                </v-alert>
            </v-flex>
        </v-layout>
        <v-layout row wrap v-show="selectedCustomer._id">
            <v-flex xs8>
                <v-layout align-center justify-start row fill-height>
                    <h1 class="title font-weight-light pt-3 pl-1"><span class="primary--text f-b">{{ selectedCustomer ? selectedCustomer.SN_ACCOUNT : '' }}</span> {{ selectedCustomer ? selectedCustomer.SN_NAME : '' }}</h1>
                </v-layout>
            </v-flex>
            <v-flex xs4>
                <v-layout align-center justify-end row fill-height>
                    <v-btn icon>
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout row wrap v-show="selectedCustomer._id">
            <v-flex xs12 sm5 md5 lg4>Standard</v-flex>
            <v-flex xs12 sm7 md7 lg8>Non-Standard</v-flex>
            <v-flex xs12 sm5 md5 lg4>
                <v-card>
                    <v-container grid-list-sm class="pt-0 pb-0 pl-3 pr-3">
                        <v-layout row wrap>
                            <v-flex xs9>
                                <v-select v-model="standard" ref="standard" :items="standardData" label="Standard" menu-props="auto" :loading="isBusyStandard" @change="onStandard"></v-select>
                            </v-flex>
                            <v-flex xs3>
                                <v-select v-model="rating" :items="rateData" label="Rate" menu-props="auto" :loading="isBusyRating" @change="onRate"></v-select>
                            </v-flex>
                            <v-flex xs12>
                                <v-autocomplete
                                    v-model="material"
                                    :items="materialData"
                                    :loading="isBusyMaterial"
                                    :search-input.sync="onMaterialSearch"
                                    hide-no-data
                                    clearable
                                    item-text="DESCRIPTIO"
                                    item-value="REFERENCE"
                                    label="Material"
                                    placeholder="Start typing to search"
                                    return-object
                                    @change="onMaterialChange"
                                ></v-autocomplete>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-flex>
            <v-flex xs12 sm7 md7 lg8>
                <v-card :class="`${nonStandard.submitIsOk ? 'light-green lighten-3' : ''}`">
                    <v-container grid-list-sm class="pt-0 pb-0 pl-3 pr-3">
                        <v-layout row wrap>
                            <v-flex xs2>
                                <v-text-field label="ID" v-model="nonStandard.gID" :disabled="!hasMaterial"></v-text-field>
                            </v-flex>
                            <v-flex xs2>
                                <v-text-field label="OD" v-model="nonStandard.gOD" :disabled="!hasMaterial"></v-text-field>
                            </v-flex>
                            <v-flex xs2>
                                <v-text-field label="NoH" v-model="nonStandard.gNOH" :disabled="!hasMaterial"></v-text-field>
                            </v-flex>
                            <v-flex xs2>
                                <v-text-field label="Ø" v-model="nonStandard.gDia" :disabled="!hasMaterial"></v-text-field>
                            </v-flex>
                            <v-flex xs2>
                                <v-text-field label="PCD" v-model="nonStandard.gPCD" :disabled="!hasMaterial"></v-text-field>
                            </v-flex>
                            <v-flex xs1>
                                <v-btn fab small title="Submit" :disabled="!hasMaterial" @click="onSubmit(false)">
                                    <v-icon>done</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex xs1>
                                <v-btn fab small title="Clear" :disabled="!hasMaterial" @click="onClear">
                                    <v-icon>clear</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex xs6>
                                <v-select v-model="nonStandard.existingDie" :items="dieData" :label="`${dieData.length ? `${dieData.length} Dies Available` : '[No Dies]'}`" menu-props="auto" clearable :disabled="!hasMaterial"></v-select>
                            </v-flex>
                            <v-flex xs6>
                                <!-- <v-btn block title="Make Die" :disabled="!nonStandard.canMake" @click="onSubmit(true)">Make</v-btn> -->
                                <v-switch v-model="nonStandard.includeDiePrice" label="Include Die Price" :disabled="!nonStandard.canMake"></v-switch>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout row wrap v-show="selectedCustomer._id">
            <v-flex xs12 mt-2>
                <v-card>
                    <div class="el-clearfix">
                        <div class="pt-2 pb-1 el-float-left pt-3">
                            <span class="subheading ml-3">{{ calculatedMaterial }}</span>
                        </div>
                        <div class="pt-2 pb-1 el-float-right">
                            <v-btn color="primary" @click="onQuote">Quote Selected</v-btn>
                        </div>
                    </div>
                    <v-divider></v-divider>
                    <v-data-table :headers="headers" :items="tableData" :loading="isBusy" hide-actions class="table-padding-small text-xs-center table-even-odd">
                        <template slot="items" slot-scope="props">
                            <tr @click="onSelect(props.item._id)" :class="`${props.item.NON_STD ? 'light-green lighten-3' : ''}`"> <!-- light-green lighten-1 -->
                                <td class="IAR">{{ $format.int(props.item.RING_ID) }}</td>
                                <td class="IAR">{{ $format.int(props.item.RING_OD) }}</td>
                                <td :class="`IAR${props.item.SelR ? ' f-b blue-grey lighten-4' : ''}`">{{ $format.currency(props.item.RING_PRICE) }}</td>
                                <td class="text-xs-right">
                                    <v-checkbox v-model="props.item.SelR" hide-details class="chk-selector"></v-checkbox>
                                </td>
                                <td class="nb-back">{{ $format.int(props.item.NB) }}</td>
                                <td class="inch-back">{{ $format.number(props.item.INCH) }}</td>
                                <td class="text-xs-right">
                                    <v-checkbox v-model="props.item.SelF" hide-details v-if="props.item.FF_PRICE" class="chk-selector"></v-checkbox>
                                </td>
                                <td :class="`IAF${props.item.SelF ? ' f-b blue-grey lighten-4' : ''}`">{{ $format.currency(props.item.FF_PRICE) }}</td>
                                <td class="IAF">{{ $format.int(props.item.FF_ID) }}</td>
                                <td class="IAF">{{ $format.int(props.item.FF_OD) }}</td>
                                <td class="IAF">{{ $format.int(props.item.FF_NOH) }}</td>
                                <td class="IAF">{{ $format.int(props.item.FF_DIA) }}</td>
                                <td class="IAF">{{ $format.int(props.item.FF_PCD) }}</td>
                            </tr>
                        </template>
                        <template slot="no-data">
                            <v-subheader>No data.</v-subheader>
                        </template>
                    </v-data-table>
                    <v-divider></v-divider>
                    <div class="el-clearfix">
                        <div class="pt-2 pb-1 el-float-right">
                            <v-btn color="primary" @click="onQuote">Quote Selected</v-btn>
                        </div>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'Interactive',
    data() {
        return {
            title: 'Interactive',
            ViewCompany: {},
            isBusyStandard: false,
            isBusyRating: false,
            isBusyMaterial: false,
            isBusy: false,
            selectedCustomer: {},
            standardData: [],
            rateData: [],
            materialData: [],
            searchText: '',
            onMaterialSearch: null,
            hasMaterial: false,
            standard: 'BS4504',
            rating: '-',
            material: '(material)',
            calculatedMaterial: '',
            inStock: '-',
            onOrder: '-',
            canPrice: false,
            nonStandard: {
                gID: '',
                gOD: '',
                gNOH: '',
                gDia: '',
                gPCD: '',
                existingDie: '',
                includeDiePrice: false,
                submitIsOk: false,
                canMake: false,
                calcPrice: '',
            },
            dieData: [],
            headers: [
                { text: 'ID', value: 'RING_ID', align: 'center', sortable: false },
                { text: 'OD', value: 'RING_OD', align: 'center', sortable: false },
                { text: 'Price', value: 'RING_PRICE', align: 'center', sortable: false },
                { text: '', value: 'SelR', align: 'right', sortable: false, width: '30px' },
                { text: 'NB', value: 'NB', align: 'center', sortable: false },
                { text: 'Inch', value: 'INCH', align: 'center', sortable: false },
                { text: '', value: 'SelF', align: 'right', sortable: false, width: '30px' },
                { text: 'Price', value: 'FF_PRICE', align: 'center', sortable: false },
                { text: 'ID', value: 'FF_ID', align: 'center', sortable: false },
                { text: 'OD', value: 'FF_OD', align: 'center', sortable: false },
                { text: 'NoH', value: 'FF_NOH', align: 'center', sortable: false },
                { text: 'Dia', value: 'FF_DIA', align: 'center', sortable: false },
                { text: 'PCD', value: 'FF_PCD', align: 'center', sortable: false }
            ],
            lastId: 0,
            tableData: []
        };
    },
    mounted() {
        this.$root.$on('CompanySwitched', () => {
            this.ViewCompany = this.$ls.get('ViewCompany', {});
            this.loadData();
        });

        this.user = this.$ls.get('User');
        Object.defineProperty(this.user, 'has', { value: this.$has });
        this.ViewCompany = this.$ls.get('ViewCompany', {});
        this.selectedCustomer = this.ContextCustomer;
        this.loadStandards();
    },
    methods: {
        gotoCustomers() {
            this.$router.push({ name: 'Customers' });
        },
        async loadStandards() {
            try {
                this.isBusyStandard = true;
                const response = await this.$http.post('/Stock/standards-unique', { C_Id: this.ViewCompany._id });
                this.standardData = response.data.d;
                this.loadRatings();
                if (this.$refs.search) setTimeout(() => this.$refs.search.focus(), 250);
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'An error occurred fetching the data.' });
            }
            finally {
                this.isBusyStandard = false;
            }
        },
        async loadRatings() {
            try {
                this.isBusyRating = true;
                const response = await this.$http.post('/Stock/standard-ratings', { C_Id: this.ViewCompany._id, Standard: this.standard });
                this.rateData = response.data.d.map(o => o._id);
                this.rating = this.rateData[this.standard === 'BS4504' ? 1 : 0];
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'An error occurred fetching the data.' });
            }
            finally {
                this.isBusyRating = false;
            }
        },
        async loadMaterial() {
            this.searchText = (this.searchText || '').trim();
            if (!this.searchText) return;

            try {
                this.isBusyMaterial = true;
                const response = await this.$http.post('/Stock/materials', { C_Id: this.ViewCompany._id, AccNo: this.selectedCustomer.SN_ACCOUNT, Material: this.searchText.trim(), Standard: this.standard, Rate: this.rating }); // TODO: SPP
                this.materialData = response.data.d;
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'An error occurred fetching the data.' });
            }
            finally {
                this.isBusyMaterial = false;
            }
        },
        async loadIBCFF() {
            if (!this.material) return;

            try {
                this.isBusy = true;
                const response = await this.$http.post('/Stock/ibcff', { C_Id: this.ViewCompany._id, AccNo: this.selectedCustomer.SN_ACCOUNT, Reference: this.material.REFERENCE, Standard: this.standard, Rate: this.rating, Discount: 0 }); // TODO: SPP, Discount
                this.tableData = response.data.d;
                this.lastId = this.tableData[this.tableData.length - 1]._id;
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'An error occurred fetching the data.' });
            }
            finally {
                this.isBusy = false;
            }
        },
        async loadIBCFFNonStandard(id, od, noh, diah, pcd, material, makeDie, accNo, disc) {
            if (!this.material) return;
            // console.warn(id, od, noh, diah, pcd, material, makeDie, accNo, disc);

            try {
                this.isBusy = true;
                const response = await this.$http.post('/Stock/ibcff-non-standard', { C_Id: this.ViewCompany._id, id, od, noh, diah, pcd, material, makeDie, accNo, disc });
                const d = response.data.d;
                this.dieData = d.dies;

                // const disType = d.disc.DISTYPE ? d.disc.DISTYPE.substr(2, 1) : '';
                this.nonStandard.calcPrice = d.priceF;
                this.canPrice = true;
                // if (DieResult[2][0] == "S" || disType == "6" || disType == "8")
                /* if (d.disc.SPPLIST === 'S' || disType == '6' || disType == '8') imgNettPriceGrd.visible = true;
                else imgNettPriceGrd.visible = false; */

                this.removeNonRecord(); // Remove existing non-standard record if there is one.
                this.lastId += 1;
                let pos = 0;
                if (id > this.tableData[0].RING_ID) {
                    pos = 0;
                    for (let i = 0; i < this.tableData.length; i++) {
                        if (id < this.tableData[i].RING_ID) {
                            pos = i;
                            break;
                        }
                    }
                }

                const newRec = {
                    _id: this.lastId,
                    RING_ID: id,
                    RING_OD: od,
                    RING_PRICE: d.priceR,
                    /* NB: 55,
                    INCH: 0.38,
                    NONSTD: 1, */
                    CN_ANAL: d.anal,
                    NON_STD: true
                };
                if (pcd !== -1) {
                    newRec.FF_PRICE = d.priceF;
                    newRec.FF_ID = id;
                    newRec.FF_OD = od;
                    newRec.FF_NOH = noh;
                    newRec.FF_DIA = diah;
                    newRec.FF_PCD = pcd;
                }
                this.tableData.splice(pos, 0, newRec);

                this.nonStandard.submitIsOk = true;
                if (!d.dies.length) {
                    this.nonStandard.canMake = false;
                }
                else {
                    this.nonStandard.canMake = true;
                    this.nonStandard.includeDiePrice = false;
                }
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'An error occurred fetching the data.' });
            }
            finally {
                this.isBusy = false;
            }
        },
        async checkSelectedProducts(descriptions) {
            // Checks:
            // 1. Check if the item can be found in CNAME.
            // 2. If found, use that CN_ANAL and CN_FACT.
            // 3. If not, use NOSTOCK.
            try {
                this.$process({ message: 'Checking products ...' });
                const response = await this.$http.post('/Stock/check-descriptions', { C_Id: this.ViewCompany._id, Desc: descriptions });
                return response.data.d;
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'An error occurred trying to check stock.' });
                return null;
            }
            finally {
                this.$process({ show: false });
            }
        },
        onSelect(id) {
            const classes = window.event.target.className;
            const type = classes.indexOf('IAR') > -1 ? 'IAR' : (classes.indexOf('IAF') > -1 ? 'IAF' : '');
            if (['IAR', 'IAF'].indexOf(type) === -1) {
                // this.$alert({ type: 'warning', title: 'Selection', message: 'Please select a Ring price (left) or a Full-face price (right).' });
                return;
            }
            const row = this.tableData.find(o => o._id === id);
            if (type === 'IAR') row.SelR = !row.SelR;
            else if (type === 'IAF') row.SelF = !row.SelF;
            const idx = this.tableData.indexOf(row);
            this.$set(this.tableData, idx, row);
            /* const data = {
                Desc: `${this.material.DESCRIPTIO} ${this.standard} ${this.rating}`,
                NB: row.NB,
                INCH: row.INCH
            };
            if (type === 'IAR') {
                data.Type = type;
                data.ID = row.RING_ID;
                data.OD = row.RING_OD;
                data.PRICE = row.RING_PRICE;
            }
            else {
                data.Type = type;
                data.ID = row.FF_ID;
                data.OD = row.FF_OD;
                data.NOH = row.FF_NOH;
                data.DIA = row.FF_DIA;
                data.PCD = row.FF_PCD;
                data.PRICE = row.FF_PRICE;
            }
            this.$router.push({ name: 'Quote', query: { product: { type: 'interactive', data: [data] } } }); */
        },
        /* addNew() {
            this.$router.push({ name: 'CustomerDetail', query: { id: '' } });
        } */
        onStandard() {
            this.loadRatings();
        },
        onRate() {},
        onMaterialChange() {
            this.hasMaterial = true;
            this.calculatedMaterial = `${this.makeMaterialDescription('IAR')} / ${this.makeMaterialDescription('IAF')}`;
            this.loadIBCFF();
        },
        makeMaterialDescription(type) {
            let desc = this.material.DESCRIPTIO.split(' ');
            if (desc.length > 2) {
                if (desc[desc.length - 1].toLowerCase() === 'x' && !isNaN(desc[desc.length - 2])) { // e.g. 3 INSERTION 1200 X
                    desc = desc.slice(0, desc.length - 2).join(' ');
                }
                else if (!isNaN(desc[desc.length - 1]) && desc[desc.length - 2].toLowerCase() === 'x' && !isNaN(desc[desc.length - 3])) { // e.g. 3 INSERTION RING 8 X 43
                    desc = desc.slice(0, desc.length - 3).join(' ');
                }
            }
            // return desc;
            return `${desc} ${type === 'IAR' ? 'RING' : 'FF'} `;
        },
        makeRecord(row, type) {
            // const desc = this.makeMaterialDescription(type);
            // const fullDesc = [`${desc} ${type === 'IAR' ? 'RING' : 'FF'} `];

            const fullDesc = [this.makeMaterialDescription(type)];
            if (row.NON_STD) { // Non-standard.
                if (type === 'IAR') fullDesc.push(`${row.RING_ID} X ${row.RING_OD}`);
                else fullDesc.push(`${row.FF_ID} X ${row.RING_OD} ${row.FF_NOH}HØ${row.FF_DIA} ${row.FF_PCD}`);
            }
            else {
                fullDesc.push(`NB ${row.NB} ${this.standard === 'ASA' ? 'ASA' : 'T'}${this.rating}`); // Standard.
            }
            const data = {
                Desc: fullDesc.join(''), // `${desc} ${type === 'IAR' ? 'RING' : 'FF'} NB ${row.NB} T${this.rating}`, // Desc: `${this.material.DESCRIPTIO} ${this.standard} ${this.rating}`, Updated to remove X (by)
                // cboMat.selectedItem.MatName + " Ring NB" + rec.NB  + " T" +cboRate.selectedItem;
                NB: row.NB,
                INCH: row.INCH,
                CN_REF: 'NON STOCK EA', // this.material.REFERENCE,
                CN_ANAL: '20000000' // row.CN_ANAL,
            };
            if (type === 'IAR') {
                data.Type = type;
                data.ID = row.RING_ID;
                data.OD = row.RING_OD;
                data.PRICE = row.RING_PRICE;
            }
            else {
                data.Type = type;
                data.ID = row.FF_ID;
                data.OD = row.FF_OD;
                data.NOH = row.FF_NOH;
                data.DIA = row.FF_DIA;
                data.PCD = row.FF_PCD;
                data.PRICE = row.FF_PRICE;
            }
            return data;
        },
        async onQuote() {
            const data = [];
            this.tableData.forEach(o => {
                if (o.SelR) data.push(this.makeRecord(o, 'IAR'));
                if (o.SelF) data.push(this.makeRecord(o, 'IAF'));
            });
            if (!data.length) {
                this.$alert({ type: 'warning', title: 'Selection', message: 'Please select at least one Ring price (left) or a Full-face price (right).' });
                return;
            }
            // Check for existing products to use code and ref.
            const existing = await this.checkSelectedProducts(data.map(o => o.Desc));
            if (existing.length) {
                existing.forEach(o => {
                    const rec = data.find(d => d.Desc === o.CN_DESC);
                    rec.CN_REF = o.CN_REF;
                    rec.CN_ANAL = o.CN_ANAL;
                });
            }
            // this.$router.push({ name: 'Quote', query: { product: { type: 'interactive', data: [data] } } });
            this.$router.push({ name: 'QuoteSession', query: { product: { type: 'INT', data } } });
        },
        // #region Non Standard.
        onSubmit() { // Was called doDies().
            let theDiscount = '0';
            // theDiscount = Application.application.discPercent.toString();
            if (theDiscount.length > 2) theDiscount = theDiscount.substr(0, 2);
            else theDiscount = '0';  // A percentage less than 10% is going to be made 0 regardless (PROBLEM !!!!!!!!!!!!!!!) (Hans comment)

            if (!this.nonStandard.gID || !this.nonStandard.gOD) {
                this.$alert({ type: 'warning', title: 'Input Error', message: 'ID and OD are required fields.' });
                return;
            }

            const gID = this.nonStandard.gID * 1;
            const gOD = this.nonStandard.gOD * 1;
            const gNOH = this.nonStandard.gNOH === '' ? -1 : this.nonStandard.gNOH * 1;
            const gDia = this.nonStandard.gDia === '' ? -1 : this.nonStandard.gDia * 1;
            const gPCD = this.nonStandard.gPCD === '' ? -1 : this.nonStandard.gPCD * 1;
            const bMake = this.nonStandard.includeDiePrice;

            if ((gNOH !== -1 || gDia !== -1 || gPCD !== -1) &&
                (gNOH === -1 || gDia === -1 || gPCD === -1)) {
                this.$alert({ type: 'warning', title: 'Input Error', message: 'NoH, Ø and PCD are all required for full-face.' });
                return;
            }
            if (gPCD !== -1) {
                if ((gPCD <= gID + gDia) || gPCD >= gOD - gDia) {
                    this.$alert({ type: 'warning', title: 'Input Error', message: 'Invalid PCD input. Please revise your PCD before trying again.' });
                    this.nonStandard.calcPrice = '';
                    return;
                }
            }

            this.loadIBCFFNonStandard(
                gID,
                gOD,
                gNOH,
                gDia,
                gPCD,
                this.material.REFERENCE,
                bMake,
                this.selectedCustomer.SN_ACCOUNT,
                theDiscount);
        },
        onClear() {
            this.canPrice = false;
            this.nonStandard = {
                gID: '',
                gOD: '',
                gNOH: '',
                gDia: '',
                gPCD: '',
                existingDie: '',
                includeDiePrice: false,
                submitIsOk: false,
                canMake: false,
                calcPrice: '',
            };
            this.removeNonRecord();
        },
        removeNonRecord() {
            // Remove the special record.
            const rec = this.tableData.find(o => o.NON_STD === true);
            if (rec) {
                const pos = this.tableData.indexOf(rec);
                this.tableData.splice(pos, 1);
            }
        }
        // #region.
    },
    watch: {
        onMaterialSearch(value) {
            value = (value || '').trim();
            this.searchText = value;
            clearTimeout(this.searchTimer);
            if (value === '') {
                this.isBusyMaterial = false;
                this.tableData = [];
                return;
            }
            this.searchTimer = setTimeout(this.loadMaterial.bind(this), 600);
        }
    }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/PriceList/Interactive.vue